import React from 'react';
import { Inbox } from 'lucide-react';

/**
 * EmptyState — used when a list/table has no data.
 */
export const EmptyState = ({ icon: Icon = Inbox, title = 'Nothing to show yet', description, actions, testId }) => (
  <div className="kr-empty" data-testid={testId}>
    <div className="kr-empty-icon">
      <Icon size={26} />
    </div>
    <h3 className="kr-empty-title">{title}</h3>
    {description && <p className="max-w-md mx-auto text-sm" style={{ color: 'var(--kr-muted)' }}>{description}</p>}
    {actions && <div className="mt-4 flex items-center justify-center gap-2">{actions}</div>}
  </div>
);

export default EmptyState;
